export default function lqdPageRefresh($) {

  elementor.channels.editor.on( 'lqd_page_refresh', async () => {

    const $lqdRefreshBtn = $('.liquid-page-refresh');
  
    $lqdRefreshBtn.attr('disabled', true);

    if ( ! elementor.saver.isEditorChanged() ) {
			_.defer(() => {
        $lqdRefreshBtn.removeAttr( 'disabled' );
      });
		}
  
    await $e.run('document/save/update', { force: true });

    elementor.reloadPreview();
    elementor.once( 'preview:loaded', () => {
      _.defer(() => {
        $lqdRefreshBtn.removeAttr( 'disabled' );
        $e.route( 'panel/page-settings/settings' )
      });
    });

  });

}
